import { Link } from "@caspeco/casper-ui-library.components.link";

export default function EmailLink({ email }: { email: string }) {
    return <Link href={`mailto:${email}`}>{email}</Link>;
}
